import React from 'react';
import SocialActions from "./social/SocialActions";
import classnames from 'classnames';
import {getMessageValue} from "@ignitesales/neuro-application/src/i18n/messageUtil";
import {Sidebar} from "@ignitesales/diana-components";
import {Route} from "react-router-dom";
import ReactSVG from "react-svg";

const Header = ({appIsLoading, className, page, processingNavigation, user, isBranchGuide}) => {
  // Test.

  const cssBem = 'header';
  const classes = classnames(cssBem, className);

  const sidebar = isBranchGuide ? <Sidebar user={user} /> : null;

  return <header className={classes}>
    <div className="container">
      { !appIsLoading && <div className={`${cssBem}__logo`}><img src={getMessageValue('en', 'logo')} alt="logo" /></div> }

      {!appIsLoading && <Route path={["/guide/spa/:uuid/:path/:page"]} children={({match}) => {
        return match && page && processingNavigation
          ? <div className="pageIsProcessing"><ReactSVG src="/classpath/assets/images/loading.svg"/></div>
          : null
      }}/>}
      { !appIsLoading ? <SocialActions/> : null }
      {sidebar}
    </div>
  </header>;
};

export default Header;
